import React, { useEffect, useState} from 'react'
import { Row, Col, Form, Card, Button, Divider, Checkbox, Input } from 'antd'
import { connect } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
    SaveIco,
    SaveBlueIco,
    RefreshIco, SearchIco, MinusSmallIco, PlusSmallIco,
    EroorIco,
} from "../../../../../modules/CustomIcons"


import './index.scss'
import '../../transfer.scss'
import {OWNACCOUNT} from "constants/constants";
import {
    checkAmountForRequest,
    fillCurrentForm,
    fillCurrentFormTemplate,
    financial,
    resetForm
} from "../../../../services/helper";
import {Account, getAccounts, getSavedDocuments} from "../../../../services/account";
import {SelectOptions} from "../../../../services/form";
import {getCurrentCompany, getUserData} from "../../../../services/user";
import AmountField from "components/AmountField";
import NextModal from "components/NextModal";
import {getEdvDocumentNumber} from "../../../../services/Accounts/DocumentNumber";
import {newMoneyTransferEdv} from "../../../../services/Transfers/Edv";
import TemplatePopup from "components/TemplatePopup";
import {getCustomerCommission} from "../../../../services/Customers/Commission";
import SaveAsTemplate from "components/SaveAsTemplate";
import {useLocation} from "react-router-dom";
import FullScreenLoading from "components/FullScreenLoading";
import {setIbanNumber } from "../../../../store/actions/accountStatement";
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'
import {deleteFileById} from "../../../../services/Transfers/Files";




const Edv: React.FC<any> = ({ ownProps, ibanNumber }) => {
    const {t} = useTranslation();

    const modalDataInitial={
        modalTitle : t("home.budgetVAT"),
        groups : [],
        note: '',
        // note : `Hal-hazırda, bu ödəniş növü üzrə əməliyyat vaxtı deyil. Banka göndərildiyi təqdirdə, köçürmə növbəti əməliyyat vaxtında emal olunacaqdır.`,
        pdfFiles : [],
        buttons : [
            {save : true},
            {sign : true},
            {approve : true},
            {send : true}
        ]
    };
    const [visible, setVisible] = useState(false);
    const [allAccounts, setAllAccounts]=useState<Account[]>();
    const [fromSelectOptions, setFromSelectOptions]=useState<SelectOptions[]>();
    const [fromBranch, setFromBranch]=useState<Account>();
    const [modalData, setModalData] = useState(modalDataInitial);
    const [documentNumber, setDocumentNumber] = useState<string>('');
    const [nextModalVisible, setNextModalVisible] = useState(false);
    const [templatePopupVisible, setTemplatePopupVisible] = useState(false);
    const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
    const [commissionLoading, setCommissionLoading]=useState(false);
    const [commissionAmount, setCommissionAmount]=useState('');
    const [voenError, setVoenError]=useState(false);
    const [loadingAccount, setLoadingAccount] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [ibankRef, setIbankRef] = useState<string>('');
    const [pdfCount, setPdfCount] = useState(0);
    const [fileList, setFileList] = useState<any[]>([])
    const [tableData, setTableData] = useState<any[]>([])
    const [editOrRepeat,setEdit] = useState(false)
    const [temp_data, setTempData] = useState<any[]>([])
    const [form] = Form.useForm();
    const location=useLocation();
    const { setIbanNumber } = useActions();

    const updateParentComponentFormData = () => {
        if (ownProps?.getFormElements){
            ownProps?.getFormElements({form});
        }
    }

    const addOrEditPage = ownProps?.addOrEditPage || false;

    const fetchData = async () => {
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());

        let temp_data=[];

        for (let row of data ){
            if(row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }


        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);

        /**/
        if (location?.state?.trnData){
            fillCurrentForm(form, location.state.trnData)
        }
        setLoadingAccount(false);
    };

    useEffect(() => {
     
        if(location.state?.data)
            loadData()
        else if(location.state?.trnData)
            loadDataTemplate2(location.state)
        else
            fetchData();

    }, [location.state]);

    const loadData = async () => {
        setLoadingAccount(true);
        setLoadingData(true)
        const data = await getAccounts(getCurrentCompany());

        let temp_data=[];

        const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
        setFileList(pdf.data?.fileDetailsList)
        if (location.state?.edit){
            setEdit(true)
        }else{
            setEdit(false)
        }
        for (let row of data ){
            if(row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }


        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        if(location.state?.edit)
            setIbankRef(location.state?.data['ibankRef'])
        setPdfCount(location.state?.data['attachedPDF'])
        /**/
        if (location?.state?.trnData){
            fillCurrentForm(form, location.state.trnData)
        }
        setLoadingAccount(false);
        // setFileList(location.state?.data['PDF_LIST'])
        setTableData(location.state?.data)
        // CUSTACC
            const findAccount = data?.find(row => row.IBAN == location.state?.data['CUSTACC'] && row.STATUS !== "0");
            setFromBranch(findAccount);

            if ((form.getFieldValue('PMTCUSTID') === "" || form.getFieldValue('PMTCUSTID') === undefined) && location.state?.edit === undefined) {
                updateDocumentNumber();
            } else if(location.state?.edit) {
                form.setFieldsValue({
                    'PMTCUSTID' : location.state?.data['PMTCUSTID']
                });
            }
            form.setFieldsValue({
                'CUSTACC' : location.state?.data['CUSTACC']
            });
        // receiver_name
            form.setFieldsValue({
                'BENEFNAME' : location.state?.data['BENEFNAME']
            });
        form.setFieldsValue({
            'NOTE' : location.state?.data['NOTE']
        });
        // BENEFTAXID
            form.setFieldsValue({
                'BENEFTAXID' : location.state?.data['BENEFTAXID']
            });
        // AMOUNT
            form.setFieldsValue({
                'AMOUNT' : checkAmountForRequest(location.state?.data['AMOUNT'])
            });
        // PMTDET
            form.setFieldsValue({
                'PMTDET' : location.state?.data['PMTDET']
            });
        // PMTDET
            form.setFieldsValue({
                'INFOTOBENEF' : location.state?.data['INFOTOBENEF']?.length >195 ? location.state?.data['INFOTOBENEF'].substring(0,195) : location.state?.data['INFOTOBENEF']
            });

        let value1=checkAmountForRequest(location.state?.data['AMOUNT']);

        if (!isNaN(value1)){
            setCommissionLoading(true);

            getCustomerCommission({
                PAYMENT_TYPE : "EDV",
                CIF : getCurrentCompany().customerNo,
                CUSTACC : findAccount?.IBAN,
                AMOUNT : value1,
                CUR : findAccount?.CCY_NAME,
                BENEFBANKCODE : form.getFieldValue('BENEFBANKCODE'),
                BENEFACC : form.getFieldValue('BENEFACC'),
                BENEFTAXID : location.state?.data['BENEFTAXID'],
                PMTDET : location.state?.data['PMTDET'],
            }).then(res => {
                setCommissionLoading(false);


                form.setFieldsValue({
                    'COMMAMOUNT' : res.COM_AMOUNT ?? ''
                });

                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')

            })
        }else{
            setCommissionLoading(false);

            form.setFieldsValue({
                'COMMAMOUNT' : ''
            });

            setCommissionAmount(old_value => '');
        }
        form.setFieldsValue({
            'INFOTOBENEF' : location.state?.data['INFOTOBENEF']?.length >195 ? location.state?.data['INFOTOBENEF'].substring(0,195) : location.state?.data['INFOTOBENEF']
        });
        setLoadingData(false)
    }

    const loadDataTemplate = async (tempData) => {
        console.log('560sab')
        setLoadingData(true)
        const docid = documentNumber;
        form.resetFields();
        if (tempData?.trnData) {
            fillCurrentFormTemplate(form, tempData?.trnData)
            updateParentComponentFormData();
        }
        if(docid !== "" && docid !== undefined) {
            console.log('isledi 270')
            form.setFieldsValue({
                'PMTCUSTID': docid
            });
            setDocumentNumber(old_value => docid)
            
        }
        form.setFieldsValue({
            'INFOTOBENEF' : tempData?.trnData?.INFOTOBENEF?.length >195 ? tempData?.trnData?.INFOTOBENEF.substring(0,195) :tempData?.trnData?.INFOTOBENEF
        });
        // CUSTACC
        const findAccount = allAccounts?.find(row => row.IBAN == tempData?.trnData.CUSTACC && row.STATUS !== "0");
        setFromBranch(findAccount);
       
        if(findAccount !== undefined) {
            
            // if (docid === "" || docid === undefined) {
                updateDocumentNumber(tempData);
            // }
            form.setFieldsValue({
                'INFOTOBENEF' : tempData?.trnData?.INFOTOBENEF?.length >195 ? tempData?.trnData?.INFOTOBENEF?.substring(0,195) :tempData?.trnData?.INFOTOBENEF
            });
        }


        form.setFieldsValue({
            'CUSTACC' : tempData?.trnData.CUSTACC
        });
        // receiver_name
        form.setFieldsValue({
            'BENEFNAME' : tempData?.trnData.BENEFNAME
        });
        form.setFieldsValue({
            'NOTE' : tempData?.trnData.NOTE
        });
        // BENEFTAXID
        form.setFieldsValue({
            'BENEFTAXID' : tempData?.trnData.BENEFTAXID
        });
        // AMOUNT
        form.setFieldsValue({
            'AMOUNT' : checkAmountForRequest(tempData?.trnData.AMOUNT)
        });
        // PMTDET
        form.setFieldsValue({
            'PMTDET' : tempData?.trnData.PMTDET
        });
      
        // BENEFBANKCODE
        form.setFieldsValue({
            'BENEFBANKCODE' : '210027'
        });

        // BENEFBANKNAME
        form.setFieldsValue({
            'BENEFBANKNAME' : t("newTransfer.stateTreasuryAgencyVAT")
        });

        let value1=checkAmountForRequest(tempData?.trnData.AMOUNT);
       
        form.setFieldsValue({
            'INFOTOBENEF' : tempData?.trnData?.INFOTOBENEF?.length >195 ? tempData?.trnData?.INFOTOBENEF.substring(0,195) :tempData?.trnData?.INFOTOBENEF
        });
        if (!isNaN(value1)){
            setCommissionLoading(true);

            getCustomerCommission({
                PAYMENT_TYPE : "EDV",
                CIF : getCurrentCompany().customerNo,
                CUSTACC : findAccount?.IBAN,
                AMOUNT : value1,
                CUR : findAccount?.CCY_NAME,
                BENEFBANKCODE : tempData?.trnData.BENEFBANKCODE,
                BENEFACC : tempData?.trnData.BENEFACC,
                BENEFTAXID : tempData?.trnData.BENEFTAXID,
                PMTDET : tempData?.trnData.PMTDET,
            }).then(res => {
                setCommissionLoading(false);


                form.setFieldsValue({
                    'COMMAMOUNT' : res.COM_AMOUNT ?? ''
                });

                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')

            })
        }
        else{
            setCommissionLoading(false);

            form.setFieldsValue({
                'COMMAMOUNT' : ''
            });

            setCommissionAmount(old_value => '');
        }


        // INFOTOBENEF
        form.setFieldsValue({
            'INFOTOBENEF' : tempData?.trnData?.INFOTOBENEF?.length >195 ? tempData?.trnData?.INFOTOBENEF?.substring(0,195) :tempData?.trnData?.INFOTOBENEF
        });
      
        setLoadingData(false)
    }

    const loadDataTemplate2 = async (tempData) => {
       
        setLoadingData(true)
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        let temp_data=[];
        for (let row of data ){
            if(row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        // CUSTACC
        const findAccount = data?.find(row => row.IBAN == tempData?.trnData.CUSTACC && row.STATUS !== "0");
        setFromBranch(findAccount);

        if(findAccount !== undefined) {
            // if (form.getFieldValue('PMTCUSTID') === "" || form.getFieldValue('PMTCUSTID') === undefined) {
                await updateDocumentNumber();
            // }
        }

        form.setFieldsValue({
            'CUSTACC' : tempData?.trnData.CUSTACC
        });
        // receiver_name
        form.setFieldsValue({
            'BENEFNAME' : tempData?.trnData.BENEFNAME
        });
        form.setFieldsValue({
            'NOTE' : tempData?.trnData.NOTE
        });
        // BENEFTAXID
        form.setFieldsValue({
            'BENEFTAXID' : tempData?.trnData.BENEFTAXID
        });
        // AMOUNT
        form.setFieldsValue({
            'AMOUNT' : checkAmountForRequest(tempData?.trnData.AMOUNT)
        });
        // PMTDET
        form.setFieldsValue({
            'PMTDET' : tempData?.trnData.PMTDET
        });
        // PMTDET
        form.setFieldsValue({
            'INFOTOBENEF' : tempData?.trnData?.INFOTOBENEF?.length >195 ? tempData?.trnData?.INFOTOBENEF.substring(0,195) :tempData?.trnData?.INFOTOBENEF
        });

        // BENEFBANKCODE
        form.setFieldsValue({
            'BENEFBANKCODE' : '210027'
        });

        // BENEFBANKNAME
        form.setFieldsValue({
            'BENEFBANKNAME' : t("newTransfer.stateTreasuryAgencyVAT")
        });

        let value1=checkAmountForRequest(tempData?.trnData.AMOUNT);

        if (!isNaN(value1)){
            setCommissionLoading(true);

            const res = await getCustomerCommission({
                PAYMENT_TYPE : "EDV",
                CIF : getCurrentCompany().customerNo,
                CUSTACC : findAccount?.IBAN,
                AMOUNT : value1,
                CUR : findAccount?.CCY_NAME,
                BENEFBANKCODE : tempData?.trnData.BENEFBANKCODE,
                BENEFACC : tempData?.trnData.BENEFACC,
                BENEFTAXID : tempData?.trnData.BENEFTAXID,
                PMTDET : tempData?.trnData.PMTDET,
            })

            if(res !== undefined) {
                setCommissionLoading(false);
                form.setFieldsValue({
                    'COMMAMOUNT' : res.COM_AMOUNT ?? ''
                });
                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            }
        }
        else{
            setCommissionLoading(false);

            form.setFieldsValue({
                'COMMAMOUNT' : ''
            });

            setCommissionAmount(old_value => '');
        }
        updateParentComponentFormData()
        form.setFieldsValue({
            'INFOTOBENEF' : tempData?.trnData?.INFOTOBENEF?.length >195 ? tempData?.trnData?.INFOTOBENEF.substring(0,195) :tempData?.trnData?.INFOTOBENEF
        });


        setLoadingData(false)
    }

    const updateDocumentNumber = async (tempData?:any) => {
        const document_number = await  getEdvDocumentNumber(getCurrentCompany());
        form.setFieldsValue({
            'PMTCUSTID' : document_number
        });
        
        form.setFieldsValue({
            'INFOTOBENEF' : tempData?.trnData?.INFOTOBENEF?.length >195 ? tempData?.trnData?.INFOTOBENEF.substring(0,195) :tempData?.trnData?.INFOTOBENEF
        });
    

        setDocumentNumber(old_value => document_number)
    
    }

    const getSelectedFromBranch = (value:any) => {
        const findAccount=allAccounts?.find(row => row.IBAN==value);
        setFromBranch(findAccount);

        if (!form.getFieldValue('PMTCUSTID') && value){
            updateDocumentNumber();
        }
        

    }


    useEffect(() => {
        if(ibanNumber.iban && allAccounts && ibanNumber.ccy_name?.toString()?.toLowerCase() === 'azn'){
        const findAccount=allAccounts?.find(row => row.IBAN==ibanNumber.iban);
        setFromBranch(findAccount);

        if (!form.getFieldValue('PMTCUSTID') && ibanNumber.iban){
            updateDocumentNumber();
        }

        setIbanNumber({iban: undefined, ccy_name: undefined})
        }

      }, [ibanNumber, allAccounts])

useEffect(() => {
    setPdfCount(form.getFieldValue('pdf_files')?.length)
},[form.getFieldValue('pdf_files')])

    const newTransferFunc = async(RequestType : string) => {
        let amount=checkAmountForRequest(form.getFieldValue('AMOUNT'));
        let pdf_files=form.getFieldValue('pdf_files') ?? [];
        if(ibankRef !== "") {
               await   deleteFileById(ibankRef)
               await new Promise(res => setTimeout(res, 1000)); 
              }
        return newMoneyTransferEdv({
            trnRequestType : RequestType,
            ccy : 1,
            ccyType : fromBranch?.CCY_NAME,
            PMTCUSTID : form.getFieldValue('PMTCUSTID'),
            CUSTCIF: getCurrentCompany().customerNo,
            CUSTACC : fromBranch?.IBAN,
            AMOUNT: amount,
            BENEFNAME : form.getFieldValue('BENEFNAME'),
            BENEFADDR : form.getFieldValue('BENEFADDR'),
            BENEFACC : form.getFieldValue('BENEFACC'),
            BENEFBANKCODE : form.getFieldValue('BENEFBANKCODE'),
            BENEFBANKNAME : form.getFieldValue('BENEFBANKNAME'),
            BENEFBANKADDR : form.getFieldValue('BENEFBANKADDR'),
            BENEFTAXID : form.getFieldValue('BENEFTAXID'),
            // INTERMEDBANKCODE : form.getFieldValue('INTERMEDBANKCODE') ?? null,
            // INTERMEDBANKADDR : form.getFieldValue('INTERMEDBANKADDR') ?? null,
            PMTDET: form.getFieldValue('PMTDET'),
            INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
            NOTE: form.getFieldValue('NOTE'),
            CUSTACCFORCOM: fromBranch?.IBAN,
            COMMAMOUNT: checkAmountForRequest(form.getFieldValue('COMMAMOUNT')) ?? 0,
            ibankRef: ibankRef,
            attachedPDF: pdfCount
        })
    }

    const submitHandler = async (args: any) => {
        await calculateCommission(args.AMOUNT);
        let amount=financial(form.getFieldValue('AMOUNT'));
        let comission=financial(form.getFieldValue('COMMAMOUNT'));
        

        let pdf_files=form.getFieldValue('pdf_files') ?? [];
        modalDataInitial.pdfFiles=[];

        if (pdf_files.length > 0){

            for(let file of pdf_files){
                modalDataInitial.pdfFiles.push({
                    'label' : file.name,
                    'file' : file
                })
            }
        }

        setModalData(old_data => ({
            ...modalDataInitial,

            groups : [
                {
                    title : false,
                    tableHasBorderBottom : true,
                    data : [
                        {
                            label : t("transfers.sender"),
                            value :  getCurrentCompany().name
                        },
                        {
                            label : t("salary.documentNo"),
                            value : `${args.PMTCUSTID}`
                        },
                        {
                            label : t("transfers.fromAccount"),
                            value : `${fromBranch?.IBAN} ${fromBranch?.CCY_NAME}`
                        },
                    ]
                },
                {
                    title : t("requisites.beneficiaryBank"),
                    tableHasBorderBottom2 : true,
                    tableHasMarginBottom : true,
                    data : [
                        {
                            label : t("requisites.code"),
                            value : `210027`
                        },
                        {
                            label : t("requisites.name"),
                            value : t("newTransfer.stateTreasuryAgencyVAT")
                        }
                    ]
                },
                {
                    title : t("requisites.beneficiary"),
                    // tableHasMarginBottom: true,
                    data : [
                        {
                            label : t("requisites.name"),
                            value : `${args.BENEFNAME}`
                        },
                        {
                            label : t("transfers.accountNumber"),
                            value :  `${args.BENEFACC}`
                        },
                        {
                            label : t("requisites.taxID"),
                            value : args.BENEFTAXID ?? ''
                        }
                    ]
                },
                {
                    title : '',
                    // tableHasBordertop : true,
                    data : [
                        {
                            label : t("common.amount"),
                            value :  `${amount} ${fromBranch?.CCY_NAME}`
                        },
                        {
                            label : t("home.commission"),
                            value : `${comission} ${fromBranch?.CCY_NAME}`
                        },
                        {
                            label : t("accountStatement.paymentDetails"),
                            value : `${args.PMTDET}`
                        },
                        {
                            label : t("transfers.infoForBeneficiary"),
                            value : args.INFOTOBENEF ?? ''
                        },
                        args.NOTE !== undefined ? {
                            label : t("newTransfer.note"),
                            value : args.NOTE ?? ''
                        } : undefined,
                    ]
                }
            ],
        }))

        setNextModalVisible(old_value => true);
    }

    const getFileList = (info : any) => {
        form.setFieldsValue({
            'pdf_files' : info.fileList
        });
    }

    const calculateCommission = async (e: any) => {
  let value;
  if (e?.target !== undefined) {
    value = checkAmountForRequest(e.target.value);
  } else {
    value = checkAmountForRequest(e);
  }

  if (!isNaN(value)) {
    setCommissionLoading(true);

    try {
      const res = await getCustomerCommission({
        PAYMENT_TYPE: "EDV",
        CIF: getCurrentCompany().customerNo,
        CUSTACC: fromBranch?.IBAN,
        AMOUNT: value,
        CUR: fromBranch?.CCY_NAME,
        BENEFBANKCODE: form.getFieldValue("BENEFBANKCODE"),
        BENEFACC: form.getFieldValue("BENEFACC"),
        BENEFTAXID: form.getFieldValue("BENEFTAXID"),
        PMTDET: form.getFieldValue("PMTDET"),
      });

      setCommissionLoading(false);

      form.setFieldsValue({
        COMMAMOUNT: res.COM_AMOUNT ?? "",
      });

      setCommissionAmount(res.COM_AMOUNT ?? "");

      // ✅ return commission for use by submitHandler
      return res.COM_AMOUNT ?? "";
    } catch (err) {
      setCommissionLoading(false);
      console.error("Commission fetch error:", err);

      form.setFieldsValue({
        COMMAMOUNT: "",
      });

      setCommissionAmount("");
      return "";
    }
  } else {
    setCommissionLoading(false);

    form.setFieldsValue({
      COMMAMOUNT: "",
    });

    setCommissionAmount("");
    return "";
  }
    };


    const openSaveAsTemplateModal = () => {

        setSaveAsTemplatePopupVisible(old_data => false)
     

        form.validateFields().then(res => {
            setSaveAsTemplatePopupVisible(old_data => true)
        }).catch(err_input_list => {

        })
    }

    const updateDocumentNumberAndCommission = (data) => {
        loadDataTemplate(data)
        setTempData(data)
       
    }

    const checkVoen = (e) => {
        let value=e?.target?.value;

        if (value?.length > 0 && value?.length  < 10){
            setVoenError(true)
        }else{
            setTimeout(() => { calculateCommission({target: {value :form.getFieldValue('AMOUNT') }}) }, 100)
            setVoenError(false)
        }


    }

    const removeFile = (index:any)=>{
        const myNewFiles = [...fileList]
        myNewFiles.splice(index, 1);
        setFileList(myNewFiles)

    }

    return (
        <>
            <Row>
                <Col  flex={'700px'} className="own-account">
                    <Card bordered={false}>
                        <Row justify='start' className="own-account__form">
                            <Form
                                labelCol={{ flex: '190px'}}
                                wrapperCol={{ flex: 1 }}
                                className='full'
                                onSubmit={(e) => e.preventDefault(e)}
                                onFinish={submitHandler}
                                id={'form'}
                                form={form}
                                autoComplete="off"
                                onValuesChange={updateParentComponentFormData}
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'center',
                                }}
                            >

                                { !addOrEditPage && <div className='flex ' >
                                    <InputField
                                        labelItem={t("salary.documentNo")}
                                        placeholder={t("salary.automatically")}
                                        name={'PMTCUSTID'}
                                        required={true}
                                        form={form}
                                        value={documentNumber}
                                        message={true}
                                        maxLength={25}
                                        allowLatinNumber ={true}
                                    />

                                    <Button
                                        size={'large'}
                                        icon={<SaveIco />}
                                        className="blue-button transfer__button flex align_center justify_center create_tr_template_btn"
                                        onClick={e => setTemplatePopupVisible(true)}
                                    >
                                        {OWNACCOUNT.PATTERN}
                                    </Button>
                                </div> }

                                <SelectField
                                    labelItem={t("transfers.fromAccount")}
                                    placeholder={t("accountStatement.chooseAccount")}
                                    options={fromSelectOptions}
                                    name={'CUSTACC'}
                                    onChange={getSelectedFromBranch}
                                    required={true}
                                    form={form}
                                    account={true}
                                    notFoundContent={!loadingAccount ? t("newTransfer.noAccountCorrespondingCurrency") : undefined}
                                    defaultValue={ibanNumber.ccy_name?.toString()?.toLowerCase() === 'azn' ? ibanNumber.iban : undefined}
                                />

                                <Divider plain orientation="left" className={'tab_divider_left'} >{t("newTransfer.beneficiaryBank")}</Divider>

                                <InputField
                                    className="dark-input not-required isReadOnly"
                                    labelItem={t("requisites.code")}
                                    placeholder=""
                                    readOnly={true}
                                    value={'210027'}
                                    maxLength={6}
                                    isNumeric={true}
                                    onlyNumber={true}
                                    form={form}
                                    staticValue={true}
                                    name={'BENEFBANKCODE'}
                                />


                                <InputField
                                    className="dark-input not-required isReadOnly"
                                    labelItem={t("requisites.name")}
                                    placeholder=""
                                    readOnly={true}
                                    value={t("newTransfer.stateTreasuryAgencyVAT")}
                                    onlyLetter={true}
                                    allowLatin={true}
                                    form={form}
                                    staticValue={true}
                                    name={'BENEFBANKNAME'}
                                />

                                <Divider plain orientation="left" className={'tab_divider_left'} >Alan</Divider>

                                <InputField
                                    labelItem={t("requisites.name")}
                                    placeholder={t("newTransfer.nameBeneficiary")}
                                    className=""
                                    maxLength={35}
                                    showCount={true}
                                    name={'BENEFNAME'}
                                    required={true}
                                    // onlyLetter={true}
                                    allowLatin={true}
                                    form={form}
                                    readOnly={!fromBranch?.ACCOUNT_NO}
                                    className={'isDisabled'}
                                />

                                <InputField
                                    labelItem={t("deposit.accountNumber")}
                                    placeholder=""
                                    value={'AZ48CTRE00000000000000014001'}
                                    className="dark-input not-required is_upper_case isReadOnly"
                                    maxLength={'28'}
                                    form={form}
                                    name={'BENEFACC'}
                                    readOnly={true}
                                    staticValue={true}
                                />

                                <InputField
                                    labelItem={t("requisites.taxID")}
                                    placeholder=""
                                    className="isDisabled"
                                    isNumeric={true}
                                    onlyNumber={true}
                                    required={true}
                                    maxLength={'10'}
                                    name={'BENEFTAXID'}
                                    form={form}
                                    readOnly={!fromBranch?.ACCOUNT_NO}
                                    onBlur={checkVoen}
                                    message={t("newTransfer.enterValidTaxID")}
                                    notValid={voenError}
                                />

                                <Divider className='no_text' />

                                <div className={'flex'}  >
                                    <AmountField
                                        labelItem={t("common.amount")}
                                        placeholder=""
                                        suffix={fromBranch?.CCY_NAME}
                                        name={'AMOUNT'}
                                        className={`amount_and_commission_col amount_input isDisabled`}
                                        required={true}
                                        form={form}
                                        disabled={!fromBranch?.ACCOUNT_NO}
                                        onBlur={calculateCommission}
                                    />

                                    <Col  className={'commission_col mobile-select'} >
                                        <InputField
                                            labelCol={2}
                                            labelItem={t("home.commission")}
                                            placeholder=""
                                            className="dark-input commission_input commission_border isReadOnly"
                                            readOnly={true}
                                            suffix={fromBranch?.CCY_NAME}
                                            name={'COMMAMOUNT'}
                                            value={commissionAmount}
                                            hasLoading={commissionLoading}
                                            form={form}
                                            required={true}
                                            message={''}
                                            notValid={form.getFieldValue('COMMAMOUNT') == ''}
                                        />
                                    </Col>
                                </div>

                                <TextAreaField
                                    visible={true}
                                    labelItem={t("accountStatement.paymentDetails")}
                                    placeholder=""
                                    showCount={true}
                                    maxLength={'140'}
                                    name={'PMTDET'}
                                    required={true}
                                    form={form}
                                    // allowDestination={true}
                                    allowLatin={true}
                                    readOnly={!fromBranch?.ACCOUNT_NO}
                                    className={'isDisabled'}
                                />
                           
                                <TextAreaField
                                    visible={true}
                                    labelItem={t("transfers.infoForBeneficiary")}
                                    placeholder=""
                                    showCount={true}
                                    maxLength={'195'}
                                    className={'no_required isDisabled'}
                                    form={form}
                                    name={'INFOTOBENEF'}
                                    readOnly={!fromBranch?.ACCOUNT_NO}
                                    allowLatin={true}
                                />

                                <div className={'flex'}>
                                    <Col flex={1}>
                                        <TextAreaField
                                            visible={visible}
                                            className='not-required plus_minus_area isDisabled'
                                            labelItem={t("newTransfer.note")}
                                            placeholder={t("newTransfer.notTransferableToBank")}
                                            showCount={true}
                                            maxLength={'180'}
                                            form={form}
                                            name={'NOTE'}
                                            readOnly={!fromBranch?.ACCOUNT_NO}
                                            // allowAllSymboll={true}
                                            allowLatin={true}
                                        />
                                    </Col>
                                    <Button
                                        className="icon-button add-remove-btn"
                                        icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                                        onClick={() => setVisible(!visible)}
                                    />
                                </div>

                                <FileUpload
                                    className='file-upload isDisabled'
                                    labelItem={t("newTransfer.attachPDF")}
                                    accept="application/pdf"
                                    multiple={false}
                                    required={false}
                                    form={form}
                                    name={'pdf_files'}
                                    onChange={getFileList}
                                    fileLimit={10}
                                    checkSize={true}
                                    disabled={!fromBranch?.ACCOUNT_NO}
                                    editFileList={fileList}
                                    ibankRef={ibankRef}
                                    editOrRepeat={editOrRepeat}
                                    removeFile={removeFile}
                                />

                                { !addOrEditPage && <div  className='flex button_row' >
                                    <Button
                                        size={'large'}
                                        icon={<SaveBlueIco />}
                                        className="light-button btn save_btn flex align_center justify_center"
                                        htmlType={"button"}
                                        onClick={openSaveAsTemplateModal}
                                    >
                                        {OWNACCOUNT.SAVE}
                                    </Button>

                                    <div className={'flex flex_wrap'}>


                                        <Button

                                            size={'large'}
                                            icon={<RefreshIco />}
                                            className="light-button refresh_btn btn flex align_center justify_center"
                                            onClick={(e) => { resetForm(form) }}
                                        >
                                            {t(OWNACCOUNT.REFRESH)}
                                        </Button>

                                        <Button
                                            size={'large'}
                                            htmlType="submit"
                                            className="blue-button next_btn btn flex align_center justify_center"
                                        >
                                            {OWNACCOUNT.NEXT}
                                        </Button>
                                    </div>

                                </div> }

                            </Form>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <NextModal
                errorIcon={<EroorIco />}
                callBackApi={newTransferFunc}
                visible={nextModalVisible}
                onClose={setNextModalVisible}
                data={modalData}
                className={'transfer_own_account'}
                nextModalTitle={t("home.transfer")}
                nextModalText={`Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.`}
                currentForm={form}
                tableData={tableData}
                repeatPdfList={fileList}
                transfer={true}
                editTransfer={ibankRef !== undefined && ibankRef !== '' && ibankRef !== null}
            />
\
            <TemplatePopup
                visible={templatePopupVisible}
                onClose={setTemplatePopupVisible}
                trnType={'EDV'}
                currentForm={form}
                updateAfterTemplate={updateDocumentNumberAndCommission}
            />

            <SaveAsTemplate
                visible={saveAsTemplatePopupVisible}
                onClose={setSaveAsTemplatePopupVisible}
                trnType={'EDV'}
                currentForm={form}
            />

            {
                loadingData ? <FullScreenLoading /> : <></>
            }

        </>
    )
}

const mapDispatchToProps = {setIbanNumber}

const mapStateToProps = (state: any, ownProps : any,) => ({
    ownProps : ownProps,
    ibanNumber: (state.accountsStatement && state.accountsStatement.ibanNumber) ? state.accountsStatement.ibanNumber : {}
});

export default connect(mapStateToProps, mapDispatchToProps)(Edv)
